<template>
  <div ref="SalesPersonDashboardpdf" id="SalesPersonDashboardpdf">
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="gutr mt-3">
      <div class="row">
        <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
          <div>
            <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-brand style="padding: 0.475rem 1rem">
                <h3>
                  {{ isFromTeusDashboard ? 'Client Dashboard' : 'Sales Person Dashboard' }}
                </h3>
                <div v-if="isFromTeusDashboard && (clientFilter || selectedClientName)" class="client-filter-info">
                  <small class="text-muted">
                    <i class="fa fa-filter"></i>
                    Client: <strong>{{ selectedClientName || getClientNameFromId(clientFilter) }}</strong>
                    <span v-if="salesPersonFilter">
                      | Sales Person: <strong>{{ getSalesPersonName(salesPersonFilter) }}</strong>
                    </span>
                  </small>
                </div>
                <div v-else-if="salesPersonFilter && !isFromTeusDashboard" class="client-filter-info">
                  <small class="text-muted">
                    <i class="fa fa-user"></i>
                    Sales Person: <strong>{{ getSalesPersonName(salesPersonFilter) }}</strong>
                  </small>
                </div>
              </b-navbar-brand>

              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button-group size="sm" class="ml-1 text-right">
                    <b-button
                      v-if="isFromTeusDashboard"
                      variant="outline-secondary"
                      @click="backToTeusDashboard"
                      class="mr-1"
                    >
                      <i class="fa fa-arrow-left"></i>
                      Back to TEUs
                    </b-button>
                    <b-button variant="outline-secondary" @click="previousDash"
                      >Back</b-button
                    >
                    <b-button
                      size="sm"
                      class="ml-1"
                      variant="outline-info"
                      @click="getPDF"
                    >
                      <i class="fa fa-cloud-download" aria-hidden="true"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      class="ml-1"
                      :disabled="ExcelBtnName != 'Export' ? true : false"
                      @click="exportToExcel"
                      variant="outline-info"
                    >
                      {{ ExcelBtnName }}
                      <b-spinner
                        v-if="ExcelBtnName != 'Export'"
                        small
                        label="Small Spinner"
                      ></b-spinner>
                    </b-button>
                  </b-button-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>

            <div>
              <!-- Filter Section -->
              <b-card class="mt-3">
                <b-row>
                  <b-col md="3" class="my-2">
                    <label>Date Range Type</label>
                    <model-list-select
                      :list="CustomDateList"
                      v-model="QDFilter"
                      option-value="DVal"
                      option-text="DText"
                      placeholder="Select"
                      :isDisabled="QFlag"
                      @input="getCurrentLastDate"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Date Range</label>
                    <date-range-picker
                      :always-show-calendars="showCal"
                      v-model="dateRange"
                      :startDate="startDate"
                      :endDate="endDate"
                      :locale-data="locale"
                      :disabled="DFlag ? true : false"
                      @update="getData"
                    ></date-range-picker>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Branch</label>
                    <model-list-select
                      :list="$store.getters['common/getAllBranchList']"
                      id="branchfilter"
                      v-model="branchfilter"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="All Branches"
                      @input="getData"
                      :isDisabled="
                        $sessionsStorage.get('designation') != 'Admin' ? true : false
                      "
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Sales Person</label>
                    <model-list-select
                      :list="$store.getters['common/getAllUserList']"
                      v-model="salesPersonFilter"
                      option-value="userId"
                      option-text="employeeName"
                      placeholder="All Sales Persons"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Client</label>
                    <model-list-select
                      :list="$store.getters['common/getAllClientList']"
                      v-model="clientFilter"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="All Clients"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Status</label>
                    <model-list-select
                      :list="statusList"
                      v-model="statusFilter"
                      option-value="statusVal"
                      option-text="statusText"
                      placeholder="All Status"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Assignment Type</label>
                    <model-list-select
                      :list="assignmentTypeList"
                      v-model="assignmentTypeFilter"
                      option-value="typeVal"
                      option-text="typeText"
                      placeholder="All Types"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Transport Type</label>
                    <model-list-select
                      :list="transportTypeList"
                      v-model="transportTypeFilter"
                      option-value="transportTypeVal"
                      option-text="transportTypeText"
                      placeholder="All Transport Types"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="3" class="my-2">
                    <label>Nomination Shipper</label>
                    <model-list-select
                      :list="nominationShipperList"
                      v-model="is_nomination_shipper"
                      option-value="value"
                      option-text="text"
                      placeholder="All Shippers"
                      @input="getData"
                    ></model-list-select>
                  </b-col>
                  <b-col md="6" class="my-2">
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      @click="clearFilter"
                      class="mr-2"
                      >Reset Filters</b-button
                    >
                  </b-col>
                </b-row>
              </b-card>

              <!-- Summary Cards (Always Visible) -->
              <SummaryCards :summaryData="summaryData" />

              <!-- Tabs for Different Sections -->
              <b-card class="mt-4">
                <b-tabs content-class="mt-3" card @input="onTabChange">
                  <b-tab title="Overview" active>
                    <template slot="title">
                      <i class="fa fa-dashboard"></i> Overview
                    </template>
                    <b-row>
                      <!-- Charts Section -->
                      <ChartsSection
                        :lineChartOptions="lineChartOptions"
                        :lineChartSeries="lineChartSeries"
                        :barChartOptions="barChartOptions"
                        :barChartSeries="barChartSeries"
                        :pieChartOptions="pieChartOptions"
                        :pieChartSeries="pieChartSeries"
                        :donutChartOptions="donutChartOptions"
                        :donutChartSeries="donutChartSeries"
                      />
                      
                      <!-- Leads and Clients Tables -->
                      <b-col md="12" class="mb-3">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Recent Leads</h6>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped table-sm">
                                <thead>
                                  <tr>
                                    <th>Lead ID</th>
                                    <th>Client Name</th>
                                    <th>Lead Date</th>
                                    <th>Status</th>
                                    <th>Value</th>
                                    <th>Sales Person</th>
                                    <th>Follow-up Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(lead, index) in leadsData" :key="index" @click="navigateToClientTeus(lead)" style="cursor: pointer;">
                                    <td>{{ lead.leadId }}</td>
                                    <td>{{ lead.clientName }}</td>
                                    <td>{{ formatDate(lead.leadDate) }}</td>
                                    <td>
                                      <b-badge
                                        :variant="
                                          lead.status === 'Converted'
                                            ? 'success'
                                            : lead.status === 'Pending'
                                            ? 'warning'
                                            : 'secondary'
                                        "
                                        >{{ lead.status }}</b-badge
                                      >
                                    </td>
                                    <td>{{ formatCurrency(lead.value) }}</td>
                                    <td>{{ lead.salesPerson }}</td>
                                    <td>{{ formatDate(lead.followUpDate) }}</td>
                                  </tr>
                                  <tr v-if="leadsData.length === 0">
                                    <td colspan="7" class="text-center text-muted">
                                      No data available
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </b-col>

                      <b-col md="12" class="mb-3">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Top Performing Clients</h6>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped table-sm">
                                <thead>
                                  <tr>
                                    <th>Rank</th>
                                    <th>Client Name</th>
                                    <th>Total Revenue</th>
                                    <th>Total Bookings</th>
                                    <th>Average Order Value</th>
                                    <th>Last Booking Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(client, index) in topClientsData" :key="index" @click="navigateToClientTeus(client)" style="cursor: pointer;">
                                    <td>
                                      <b-badge variant="primary">{{ index + 1 }}</b-badge>
                                    </td>
                                    <td>{{ client.clientName }}</td>
                                    <td>{{ formatCurrency(client.totalRevenue) }}</td>
                                    <td>{{ client.totalBookings }}</td>
                                    <td>{{ formatCurrency(client.avgOrderValue) }}</td>
                                    <td>{{ formatDate(client.lastBookingDate) }}</td>
                                  </tr>
                                  <tr v-if="topClientsData.length === 0">
                                    <td colspan="6" class="text-center text-muted">
                                      No data available
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </b-col>

                      <b-col md="12" class="mb-3">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Quotation Summary</h6>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped table-sm">
                                <thead>
                                  <tr>
                                    <th>Quotation No</th>
                                    <th>Client Name</th>
                                    <th>Date</th>
                                    <th>Value</th>
                                    <th>Status</th>
                                    <th>Valid Until</th>
                                    <th>Sales Person</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(quote, index) in quotationsData" :key="index">
                                    <td>{{ quote.quotationNo }}</td>
                                    <td>{{ quote.clientName }}</td>
                                    <td>{{ formatDate(quote.quotationDate) }}</td>
                                    <td>{{ formatCurrency(quote.value) }}</td>
                                    <td>
                                      <b-badge
                                        :variant="
                                          quote.status === 'Approved'
                                            ? 'success'
                                            : quote.status === 'Pending'
                                            ? 'warning'
                                            : 'danger'
                                        "
                                        >{{ quote.status }}</b-badge
                                      >
                                    </td>
                                    <td>{{ formatDate(quote.validUntil) }}</td>
                                    <td>{{ quote.salesPerson }}</td>
                                  </tr>
                                  <tr v-if="quotationsData.length === 0">
                                    <td colspan="7" class="text-center text-muted">
                                      No data available
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Leads">
                    <template slot="title">
                      <i class="fa fa-users"></i> Leads
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Leads Management</h6>
                            <small class="text-muted">Manage and track customer leads</small>
                          </div>
                          <div class="card-body">
                            <!-- Filters -->
                            <b-row class="mb-3">
                              <b-col md="3">
                                <b-form-input
                                  v-model="leadsSearch"
                                  placeholder="Search by enquiry ID or client name..."
                                  @input="debounceSearch('leads')"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-form-select
                                  v-model="leadsStatus"
                                  :options="[
                                    { value: '', text: 'All Status' },
                                    { value: 'Pending', text: 'Pending' },
                                    { value: 'Converted', text: 'Converted' },
                                    { value: 'Lost', text: 'Lost' }
                                  ]"
                                  @change="onLeadsSearch"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-form-select
                                  v-model="leadsPerPage"
                                  :options="[5, 10, 25, 50]"
                                  @change="onLeadsSearch"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  @click="loadLeadsData"
                                  :disabled="isLoading"
                                >
                                  <i class="fa fa-refresh" :class="{ 'fa-spin': isLoading }"></i>
                                  Refresh
                                </b-button>
                              </b-col>
                            </b-row>

                            <!-- Leads Table -->
                            <b-table
                              :items="leadsData"
                              :fields="leadsFields"
                              :empty-text="'No leads found'"
                              :empty-filtered-text="'No matching leads found'"
                              show-empty
                              striped
                              bordered
                              small
                              hover
                              responsive="sm"
                              @row-clicked="navigateToClientTeus"
                            >
                              <template slot="status" slot-scope="data">
                                <b-badge
                                  :variant="data.value === 'Converted' ? 'success' : data.value === 'Pending' ? 'warning' : 'danger'"
                                >
                                  {{ data.value }}
                                </b-badge>
                              </template>
                              <template slot="loginTime" slot-scope="data">
                                {{ formatDate(data.value) }}
                              </template>
                            </b-table>

                            <!-- Pagination -->
                            <b-pagination
                              v-if="leadsPagination.totalPages > 1"
                              v-model="leadsPagination.currentPage"
                              :total-rows="leadsPagination.totalItems"
                              :per-page="leadsPagination.itemsPerPage"
                              @change="onLeadsPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Top Clients">
                    <template slot="title">
                      <i class="fa fa-trophy"></i> Top Clients
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Top Performing Clients</h6>
                            <small class="text-muted">Clients with highest enquiry volume</small>
                          </div>
                          <div class="card-body">
                            <!-- Filters -->
                            <b-row class="mb-3">
                              <b-col md="2">
                                <b-form-select
                                  v-model="topClientsPerPage"
                                  :options="[5, 10, 25, 50]"
                                  @change="onTopClientsPageChange(1)"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  @click="loadTopClientsData"
                                  :disabled="isLoading"
                                >
                                  <i class="fa fa-refresh" :class="{ 'fa-spin': isLoading }"></i>
                                  Refresh
                                </b-button>
                              </b-col>
                            </b-row>

                            <!-- Top Clients Table -->
                            <b-table
                              :items="topClientsData"
                              :fields="topClientsFields"
                              :empty-text="'No top clients found'"
                              :empty-filtered-text="'No matching clients found'"
                              show-empty
                              striped
                              bordered
                              small
                              hover
                              responsive="sm"
                            >
                              <template slot="clientName" slot-scope="data">
                                <strong>{{ data.value }}</strong>
                              </template>
                              <template slot="enquiryCount" slot-scope="data">
                                <b-badge variant="primary">{{ data.value }}</b-badge>
                              </template>
                            </b-table>

                            <!-- Pagination -->
                            <b-pagination
                              v-if="topClientsPagination.totalPages > 1"
                              v-model="topClientsPagination.currentPage"
                              :total-rows="topClientsPagination.totalItems"
                              :per-page="topClientsPagination.itemsPerPage"
                              @change="onTopClientsPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Profit & Loss">
                    <template slot="title">
                      <i class="fa fa-line-chart"></i> Profit & Loss
                    </template>
                    <b-row>
                      <ProfitLossSection
                        :profitLossData="profitLossData"
                        :paginationData="profitLossPagination"
                        :summaryData="profitLossSummary"
                        @load-profit-loss-data="handleProfitLossDataLoad"
                      />
                    </b-row>
                  </b-tab>

                  <b-tab title="Expenses">
                    <template slot="title">
                      <i class="fa fa-money"></i> Expenses
                    </template>
                    <b-row>
                      <ExpenseSection :expenseData="expenseData" />
                    </b-row>
                  </b-tab>

                  <b-tab title="Tally Reverse Invoice">
                    <template slot="title">
                      <i class="fa fa-file-text"></i> Tally Reverse Invoice
                    </template>
                    <b-row>
                      <TallyReverseInvoiceSection
                        :tallyReverseInvoiceData="tallyReverseInvoiceData"
                        @data-loaded="handleTallyReverseInvoiceDataLoaded"
                      />
                    </b-row>
                  </b-tab>

                  <b-tab title="Quotations">
                    <template slot="title">
                      <i class="fa fa-file-text"></i> Quotations
                    </template>
                    <b-row>
                      <QuotationsSection
                        :quotationsData="quotationsData"
                        @data-loaded="handleQuotationsDataLoaded"
                      />
                    </b-row>
                  </b-tab>

                  <b-tab title="Assignments">
                    <template slot="title">
                      <i class="fa fa-tasks"></i> Assignments
                    </template>
                    <b-row>
                      <AssignmentSection
                        :assignmentsData="assignmentData"
                        @data-loaded="handleAssignmentDataLoaded"
                      />
                    </b-row>
                  </b-tab>

                  <!-- <b-tab title="Enquiries">
                    <template slot="title">
                      <i class="fa fa-question-circle"></i> Enquiries
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header d-flex justify-content-between align-items-center">
                            <div>
                              <h6 class="card-title mb-0">Enquiry Details</h6>
                              <small class="text-muted">Manage and track customer enquiries</small>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="search-container mr-3">
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  v-model="enquiriesSearch"
                                  @input="debounceSearch('enquiries')"
                                  placeholder="Search enquiries..."
                                  style="min-width: 200px;"
                                />
                              </div>
                              <small class="text-muted mr-2">{{ enquiriesPagination.totalItems }} enquiries</small>
                            </div>
                          </div>
                          <div class="card-body">
                            <EnquirySection :enquiryData="enquiryData" />

                            <b-pagination
                              v-if="enquiriesPagination.totalPages > 1"
                              v-model="enquiriesPagination.currentPage"
                              :total-rows="enquiriesPagination.totalItems"
                              :per-page="enquiriesPagination.itemsPerPage"
                              @change="onEnquiriesPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab> -->

                  <b-tab title="Console Booking">
                    <template slot="title">
                      <i class="fa fa-calendar-check-o"></i> Console Booking
                    </template>
                    <b-row>
                      <ConsoleBookingSection :consoleBookingData="consoleBookingData" />
                    </b-row>
                  </b-tab>

                  <b-tab title="Billing">
                    <template slot="title">
                      <i class="fa fa-credit-card"></i> Billing
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Billing Management</h6>
                            <small class="text-muted">Track and manage billing records</small>
                          </div>
                          <div class="card-body">
                            <!-- Filters -->
                            <b-row class="mb-3">
                              <b-col md="3">
                                <b-form-input
                                  v-model="billingSearch"
                                  placeholder="Search by invoice number or client name..."
                                  @input="debounceSearch('billing')"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-form-select
                                  v-model="billingPerPage"
                                  :options="[5, 10, 25, 50]"
                                  @change="onBillingSearch"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  @click="loadBillingData"
                                  :disabled="isLoading"
                                >
                                  <i class="fa fa-refresh" :class="{ 'fa-spin': isLoading }"></i>
                                  Refresh
                                </b-button>
                              </b-col>
                            </b-row>

                            <!-- Billing Table -->
                            <b-table
                              :items="billingData"
                              :fields="billingFields"
                              :empty-text="'No billing records found'"
                              :empty-filtered-text="'No matching billing records found'"
                              show-empty
                              striped
                              bordered
                              small
                              hover
                              responsive="sm"
                            >
                              <template slot="BillingSeries" slot-scope="data">
                                <code>{{ data.value }}</code>
                              </template>
                              <template slot="totalAmount" slot-scope="data">
                                {{ formatCurrency(data.value) }}
                              </template>
                              <template slot="status" slot-scope="data">
                                <b-badge
                                  :variant="data.value === 'Paid' ? 'success' : data.value === 'Pending' ? 'warning' : 'danger'"
                                >
                                  {{ data.value }}
                                </b-badge>
                              </template>
                              <template slot="billDate" slot-scope="data">
                                {{ formatDate(data.value) }}
                              </template>
                            </b-table>

                            <!-- Pagination -->
                            <b-pagination
                              v-if="billingPagination.totalPages > 1"
                              v-model="billingPagination.currentPage"
                              :total-rows="billingPagination.totalItems"
                              :per-page="billingPagination.itemsPerPage"
                              @change="onBillingPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <!-- <b-tab title="Billing Summary">
                    <template slot="title">
                      <i class="fa fa-table"></i> Billing Summary
                    </template>
                    <b-row>
                      <BillingSummarySection
                        :billingSummaryData="billingSummaryData"
                        :billingSearchQuery="billingSearchQuery"
                        :billingSortColumn="billingSortColumn"
                        :billingSortDirection="billingSortDirection"
                        @sort-billing="sortBillingBy"
                      />
                    </b-row>
                  </b-tab> -->

                  <b-tab title="Active Clients">
                    <template slot="title">
                      <i class="fa fa-users"></i> Active Clients
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Active Clients (Last 90 Days)</h6>
                            <small class="text-muted">Clients with recent assignments</small>
                          </div>
                          <div class="card-body">
                            <!-- Filters -->
                            <b-row class="mb-3">
                              <b-col md="3">
                                <b-form-input
                                  v-model="activeClientsSearch"
                                  placeholder="Search by client name..."
                                  @input="debounceSearch('activeClients')"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-form-select
                                  v-model="activeClientsPerPage"
                                  :options="[5, 10, 25, 50]"
                                  @change="onActiveClientsSearch"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  @click="loadActiveClientsData"
                                  :disabled="isLoading"
                                >
                                  <i class="fa fa-refresh" :class="{ 'fa-spin': isLoading }"></i>
                                  Refresh
                                </b-button>
                              </b-col>
                            </b-row>

                            <b-table
                              :items="activeClientsData"
                              :fields="activeClientsFields"
                              :empty-text="'No active clients in the last 90 days'"
                              :empty-filtered-text="'No matching records found'"
                              show-empty
                              striped
                              bordered
                              small
                              hover
                              responsive="sm"
                            >
                              <template slot="clientName" slot-scope="data">
                                <strong>{{ data.value }}</strong>
                              </template>
                              <template slot="activityCount" slot-scope="data">
                                <b-badge variant="primary">{{ data.value }}</b-badge>
                              </template>
                              <template slot="lastActivity" slot-scope="data">
                                {{ formatDate(data.value) }}
                              </template>
                            </b-table>

                            <!-- Pagination -->
                            <b-pagination
                              v-if="activeClientsPagination.totalPages > 1"
                              v-model="activeClientsPagination.currentPage"
                              :total-rows="activeClientsPagination.totalItems"
                              :per-page="activeClientsPagination.itemsPerPage"
                              @change="onActiveClientsPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Outstanding">
                    <template slot="title">
                      <i class="fa fa-money"></i> Outstanding
                    </template>
                    <b-row>
                      <b-col md="12" class="mb-4">
                        <b-card class="formCardDash">
                          <div class="card-header">
                            <h6 class="card-title mb-0">Outstanding Amounts</h6>
                            <small class="text-muted">Pending payments and dues</small>
                              </div>
                          <div class="card-body">
                            <div class="row mb-4">
                              <div class="col-md-6">
                                <div class="summary-card">
                                  <div class="card-icon bg-warning">
                                    <i class="fa fa-money"></i>
                            </div>
                                  <div class="card-content">
                                    <h4>{{ formatCurrency(outstandingData.totalOutstanding || 0) }}</h4>
                                    <p>Total Outstanding</p>
                            </div>
                                    </div>
                                    </div>
                              <div class="col-md-6">
                                <div class="summary-card">
                                  <div class="card-icon bg-danger">
                                    <i class="fa fa-file-text-o"></i>
                                  </div>
                                  <div class="card-content">
                                    <h4>{{ outstandingData.count || 0 }}</h4>
                                    <p>Outstanding Invoices</p>
                                </div>
                                  </div>
                                </div>
                              </div>

                            <!-- Filters -->
                            <b-row class="mb-3">
                              <b-col md="3">
                                <b-form-input
                                  v-model="outstandingSearch"
                                  placeholder="Search by invoice number or client name..."
                                  @input="debounceSearch('outstanding')"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-form-select
                                  v-model="outstandingPerPage"
                                  :options="[5, 10, 25, 50]"
                                  @change="onOutstandingSearch"
                                  size="sm"
                                />
                              </b-col>
                              <b-col md="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  @click="loadOutstandingData"
                                  :disabled="isLoading"
                                >
                                  <i class="fa fa-refresh" :class="{ 'fa-spin': isLoading }"></i>
                                  Refresh
                                </b-button>
                              </b-col>
                            </b-row>

                            <b-table
                              :items="outstandingData.outstandingInvoices || []"
                              :fields="outstandingFields"
                              :empty-text="'No outstanding invoices'"
                              :empty-filtered-text="'No matching records found'"
                              show-empty
                              striped
                              bordered
                              small
                              hover
                              responsive="sm"
                            >
                              <template slot="invoiceNumber" slot-scope="data">
                                <code>{{ data.value }}</code>
                              </template>
                              <template slot="clientName" slot-scope="data">
                                <strong>{{ data.value || 'Unknown' }}</strong>
                              </template>
                              <template slot="amount" slot-scope="data">
                                {{ formatCurrency(data.value || 0) }}
                              </template>
                              <template slot="outstandingDate" slot-scope="data">
                                {{ formatDate(data.value) }}
                              </template>
                              <template slot="status" slot-scope="data">
                                <b-badge variant="warning">{{ data.value || 'Outstanding' }}</b-badge>
                              </template>
                            </b-table>

                            <!-- Pagination -->
                            <b-pagination
                              v-if="outstandingPagination.totalPages > 1"
                              v-model="outstandingPagination.currentPage"
                              :total-rows="outstandingPagination.totalItems"
                              :per-page="outstandingPagination.itemsPerPage"
                              @change="onOutstandingPageChange"
                              class="mt-3"
                              align="center"
                              size="sm"
                            />
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
        </div>
      </div>
      <md-dialog-alert
        :md-content="alert.content"
        :md-ok-text="alert.ok"
        ref="addPop"
      ></md-dialog-alert>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import DashboardService from "../../services/DashboardService.js";
import SalesPersonTeusService from "../../services/SalesPersonTeusService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import SummaryCards from "./salesPersonDashboard/SummaryCards.vue";
import ChartsSection from "./salesPersonDashboard/ChartsSection.vue";
import ProfitLossSection from "./salesPersonDashboard/ProfitLossSection.vue";
import ExpenseSection from "./salesPersonDashboard/ExpenseSection.vue";
import TallyReverseInvoiceSection from "./salesPersonDashboard/TallyReverseInvoiceSection.vue";
import QuotationsSection from "./salesPersonDashboard/QuotationsSection.vue";
import AssignmentSection from "./salesPersonDashboard/AssignmentSection.vue";
import EnquirySection from "./salesPersonDashboard/EnquirySection.vue";
import ConsoleBookingSection from "./salesPersonDashboard/ConsoleBookingSection.vue";
import BillingSection from "./salesPersonDashboard/BillingSection.vue";
import BillingSummarySection from "./salesPersonDashboard/BillingSummarySection.vue";

export default {
  name: "SalesPersonDashboard",
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/dashboard/sales-person-dashboard");

    // Store query parameters to process after store data is loaded
    this.pendingQueryParams = Object.assign({}, this.$route.query);

    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.getCurrentLastDate();
      this.loadStaticData();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  mounted() {
    // Try to process immediately if store data is already loaded
    const userList = this.$store.getters['common/getAllUserList'];
    const clientList = this.$store.getters['common/getAllClientList'];

    if ((userList && userList.length > 0) || (clientList && clientList.length > 0)) {
      console.log('Store data already loaded, processing params immediately');
      this.processPendingQueryParams();
    }

    // Also process after a short delay as fallback
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.pendingQueryParams) {
          console.log('Fallback: processing pending params after timeout');
          this.processPendingQueryParams();
        }
      }, 1000);
    });

    // Load summary data
    this.getData();

    // Load data for each tab (only load first page initially)
    this.loadLeadsData();
    this.loadEnquiriesData();
    this.loadTopClientsData();
    this.loadQuotationsData();
    this.loadAssignmentsData();
    this.loadConsoleBookingData();
    this.loadBillingData();
    this.loadActiveClientsData();
    this.loadOutstandingData();
    this.loadProfitLossData();
    this.loadExpenseData();
    this.loadTallyReverseInvoiceData();
  },
  watch: {
    '$store.getters["common/getAllUserList"]': {
      handler(newVal) {
        console.log('User list updated:', newVal ? newVal.length : 0, 'items');
        if (newVal && newVal.length > 0 && this.pendingQueryParams) {
          console.log('Processing pending params due to user list update');
          this.processPendingQueryParams();
        }
      },
      immediate: true
    },
    '$store.getters["common/getAllClientList"]': {
      handler(newVal) {
        console.log('Client list updated:', newVal ? newVal.length : 0, 'items');
        if (newVal && newVal.length > 0 && this.pendingQueryParams) {
          console.log('Processing pending params due to client list update');
          this.processPendingQueryParams();
        }
      },
      immediate: true
    }
  },
  components: {
    CustomLoader,
    ModelListSelect,
    DateRangePicker,
    SummaryCards,
    ChartsSection,
    ProfitLossSection,
    ExpenseSection,
    TallyReverseInvoiceSection,
    QuotationsSection,
    AssignmentSection,
    EnquirySection,
    ConsoleBookingSection,
    BillingSection,
    BillingSummarySection,
  },
  data() {
    return {
      isLoading: false,
      ExcelBtnName: "Export",
      showCal: false,
      QDFilter: "1",
      QFlag: false,
      DFlag: false,
      isFromTeusDashboard: false,
      selectedClientName: null,
      pendingQueryParams: null,
      dateRange: { startDate: null, endDate: null },
      startDate: null,
      endDate: null,
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        firstDay: 0,
      },
      branchfilter: "",
      salesPersonFilter: "",
      clientFilter: "",
      statusFilter: "",
      is_nomination_shipper: "",
      assignmentTypeFilter: "all",
      transportTypeFilter: "all",
      CustomDateList: [
        { DVal: "1", DText: "Today" },
        { DVal: "2", DText: "Yesterday" },
        { DVal: "3", DText: "This Week" },
        { DVal: "4", DText: "Last Week" },
        { DVal: "5", DText: "This Month" },
        { DVal: "6", DText: "Last Month" },
        { DVal: "11", DText: "Custom Range" },
      ],
      statusList: [
        { value: "all", text: "All" },
        { value: "Pending", text: "Pending" },
        { value: "Completed", text: "Completed" },
      ],
      assignmentTypeList: [
        { typeVal: "all", typeText: "All Types" },
        { typeVal: "FF_EXP", typeText: "Freight Forwarding Export" },
        { typeVal: "FF_IMP", typeText: "Freight Forwarding Import" },
        { typeVal: "CC_EXP", typeText: "Custom Clearance Export" },
        { typeVal: "CC_IMP", typeText: "Custom Clearance Import" },
        { typeVal: "TPT", typeText: "Transport" },
      ],
      transportTypeList: [
        { transportTypeVal: "all", transportTypeText: "All" },
        { transportTypeVal: "Export", transportTypeText: "Export" },
        { transportTypeVal: "Import", transportTypeText: "Import" },
      ],
      nominationShipperList: [
        { value: "1", text: "Nominated Shippers" },
        { value: "0", text: "Free Hand Shippers" },
        { value: "", text: "All Shippers" },
      ],
      summaryData: {
        totalLeads: 245,
        convertedLeads: 128,
        pendingLeads: 89,
        totalRevenue: 1250000,
        totalQuotations: 156,
        totalBookings: 98,
        conversionRate: 52.2,
        totalClients: 45,
      },
      leadsData: [],
      topClientsData: [],
      quotationsData: [],
      profitLossData: {
        totalRevenue: 1250000,
        totalExpenses: 950000,
        netProfit: 300000,
        profitMargin: 24.0,
        details: [],
      },
      expenseData: [],
      tallyReverseInvoiceData: [],
      assignmentData: [],
      enquiryData: [],
      consoleBookingData: [],
      billingSummary: {
        totalInvoices: 156,
        totalBilledAmount: 2500000,
        paidAmount: 1800000,
        pendingAmount: 700000,
      },
      billingData: [],
      billingSearchQuery: "",
      billingSortColumn: "total",
      billingSortDirection: "desc",
      billingSummaryData: [],
      activeClientsData: [],
      outstandingData: {
        totalOutstanding: 0,
        outstandingInvoices: [],
        count: 0
      },

      // Pagination data for each tab
      leadsPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      leadsPerPage: 10,
      leadsSearch: '',
      leadsStatus: '',

      topClientsPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      topClientsPerPage: 10,

      quotationsPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      quotationsPerPage: 10,
      quotationsSearch: '',

      assignmentsPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      assignmentsPerPage: 10,
      assignmentsSearch: '',

      billingPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      billingPerPage: 10,
      billingSearch: '',

      activeClientsPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      activeClientsPerPage: 10,
      activeClientsSearch: '',

      outstandingPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      outstandingPerPage: 10,
      outstandingSearch: '',

      enquiriesPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      enquiriesPerPage: 10,
      enquiriesSearch: '',

      profitLossPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      profitLossPerPage: 10,
      profitLossSearch: '',
      profitLossSummary: {
        totalRevenue: 0,
        totalExpenses: 0,
        netProfit: 0,
        profitMargin: 0
      },

      expensesPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      expensesPerPage: 10,
      expensesSearch: '',

      tallyReverseInvoicePagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10
      },
      tallyReverseInvoicePerPage: 10,
      tallyReverseInvoiceSearch: '',

      // Search timeout for debouncing
      searchTimeout: null,

      // Table field definitions for b-table components
      leadsFields: [
        { key: 'enquiryId', label: 'Enquiry ID', sortable: true },
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'enquiryType', label: 'Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'loginTime', label: 'Date', sortable: true }
      ],

      topClientsFields: [
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'enquiryCount', label: 'Enquiry Count', sortable: true }
      ],

      quotationsFields: [
        { key: 'quotationNumber', label: 'Quotation No', sortable: true },
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'totalAmount', label: 'Amount', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'createdAt', label: 'Date', sortable: true }
      ],

      assignmentsFields: [
        { key: 'assignmentId', label: 'Assignment ID', sortable: true },
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'assignmentType', label: 'Type', sortable: true },
        { key: 'transportType', label: 'Transport', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'loginTime', label: 'Date', sortable: true }
      ],

      billingFields: [
        { key: 'BillingSeries', label: 'Invoice No', sortable: true },
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'totalAmount', label: 'Amount', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'billDate', label: 'Date', sortable: true }
      ],
      activeClientsFields: [
        { key: 'clientName', label: 'Client Name', sortable: true },
        { key: 'activityCount', label: 'Activity Count', sortable: true },
        { key: 'lastActivity', label: 'Last Activity', sortable: true }
      ],
      outstandingFields: [
        { key: 'invoiceNumber', label: 'Invoice No', sortable: true },
        { key: 'clientName', label: 'Client', sortable: true },
        { key: 'amount', label: 'Amount', sortable: true },
        { key: 'outstandingDate', label: 'Outstanding Date', sortable: true },
        { key: 'status', label: 'Status', sortable: false }
      ],
      lineChartOptions: {},
      lineChartSeries: [],
      barChartOptions: {},
      barChartSeries: [],
      pieChartOptions: {},
      pieChartSeries: [],
      donutChartOptions: {},
      donutChartSeries: [],
      alert: {
        content: "Operation completed successfully",
        ok: "OK",
      },
    };
  },
  methods: {
    getCurrentLastDate() {
      // Implementation for date handling
      const today = moment();
      this.startDate = today.clone().startOf("day");
      this.endDate = today.clone().endOf("day");
      this.dateRange = { startDate: this.startDate, endDate: this.endDate };
    },

    // Debounce search functionality
    debounceSearch(tab) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        switch(tab) {
          case 'leads':
            this.onLeadsSearch();
            break;
          case 'quotations':
            this.onQuotationsSearch();
            break;
          case 'assignments':
            this.onAssignmentsSearch();
            break;
          case 'billing':
            this.onBillingSearch();
            break;
          case 'activeClients':
            this.onActiveClientsSearch();
            break;
          // case 'enquiries':
          //   this.onEnquiriesSearch();
            break;
          case 'profitLoss':
            this.onProfitLossSearch();
            break;
          case 'expenses':
            this.onExpensesSearch();
            break;
          case 'tallyReverseInvoice':
            this.onTallyReverseInvoiceSearch();
            break;
          case 'outstanding':
            this.onOutstandingSearch();
            break;
        }
      }, 500);
    },

    // Separate API methods for each tab
    async loadLeadsData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.leadsPagination.currentPage,
          limit: this.leadsPerPage,
          search: this.leadsSearch,
          status: this.leadsStatus
        };

        const response = await SalesPersonTeusService.getLeadsData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.leadsData = data.leads || [];
          this.leadsPagination = data.pagination;
        } else {
          this.leadsData = [];
          this.alert.content = response.data.message || "Failed to fetch leads data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching leads data:', error);
        this.leadsData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching leads data";
        this.$refs.addPop.open();
      }
    },

    async loadTopClientsData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.topClientsPagination.currentPage,
          limit: this.topClientsPerPage
        };

        const response = await SalesPersonTeusService.getTopClientsData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.topClientsData = data.topClients || [];
          this.topClientsPagination = data.pagination;
        } else {
          this.topClientsData = [];
          this.alert.content = response.data.message || "Failed to fetch top clients data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching top clients data:', error);
        this.topClientsData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching top clients data";
        this.$refs.addPop.open();
      }
    },

    async loadQuotationsData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.quotationsPagination.currentPage,
          limit: this.quotationsPerPage,
          search: this.quotationsSearch
        };

        const response = await SalesPersonTeusService.getQuotationsData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.quotationsData = data.quotations || [];
          this.quotationsPagination = data.pagination;
        } else {
          this.quotationsData = [];
          this.alert.content = response.data.message || "Failed to fetch quotations data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching quotations data:', error);
        this.quotationsData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching quotations data";
        this.$refs.addPop.open();
      }
    },

    async loadAssignmentsData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          assignmentTypeFilter: this.assignmentTypeFilter,
          transportTypeFilter: this.transportTypeFilter,
          page: this.assignmentsPagination.currentPage,
          limit: this.assignmentsPerPage,
          search: this.assignmentsSearch
        };

        const response = await SalesPersonTeusService.getAssignmentsData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.assignmentData = data.assignments || [];
          this.assignmentsPagination = data.pagination;
        } else {
          this.assignmentData = [];
          this.alert.content = response.data.message || "Failed to fetch assignments data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching assignments data:', error);
        this.assignmentData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching assignments data";
        this.$refs.addPop.open();
      }
    },

    async loadBillingData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.billingPagination.currentPage,
          limit: this.billingPerPage,
          search: this.billingSearch
        };

        const response = await SalesPersonTeusService.getBillingData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.billingData = data.billing || [];
          this.billingPagination = data.pagination;
        } else {
          this.billingData = [];
          this.alert.content = response.data.message || "Failed to fetch billing data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching billing data:', error);
        this.billingData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching billing data";
        this.$refs.addPop.open();
      }
    },

    async loadActiveClientsData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter || undefined,
          page: this.activeClientsPagination.currentPage,
          limit: this.activeClientsPerPage,
          search: this.activeClientsSearch
        };

        const response = await SalesPersonTeusService.getActiveClientsData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.activeClientsData = data.activeClients || [];
          this.activeClientsPagination = data.pagination;
        } else {
          this.activeClientsData = [];
          this.alert.content = response.data.message || "Failed to fetch active clients data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching active clients data:', error);
        this.activeClientsData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching active clients data";
        this.$refs.addPop.open();
      }
    },

    async loadConsoleBookingData() {
      try {
        const payload = {
          page: 1,
          pageSize: 10,
          addUserId: this.salesPersonFilter,
          clientId: this.clientFilter || undefined,
          startDate: this.dateRange.startDate,
          endDate: this.dateRange.endDate,
          isList: 1
        };

        const response = await NodeLockPannelService.getAllConsoleBookingList(payload);
        console.log("loadConsoleBookingData response=>",response);
        if (response.data &&  response.data.data && response.data.data.length>0) {
          this.consoleBookingData = response.data.data || [];
        } else {
          this.consoleBookingData = [];
        }
      } catch (error) {
        console.error('Error fetching console booking data:', error);
        this.consoleBookingData = [];
      }
    },

    async loadEnquiriesData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter || undefined,
          page: this.enquiriesPagination.currentPage,
          limit: this.enquiriesPerPage,
          search: this.enquiriesSearch,
          dateRange: this.getDateRangeString()
        };

        const response = await SalesPersonTeusService.getEnquiriesData(payload);

        if (response.data && response.data.status) {
          this.enquiriesData = response.data.data || [];
          this.enquiriesPagination = {
            currentPage: response.data.pagination.currentPage || 1,
            totalPages: response.data.pagination.totalPages || 1,
            totalItems: response.data.pagination.totalItems || 0
          };
        } else {
          this.enquiriesData = [];
          this.alert.content = response.data.message || "Failed to fetch enquiries data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching enquiries data:', error);
        this.enquiriesData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching enquiries data";
        this.$refs.addPop.open();
      }
    },

    async loadProfitLossData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.profitLossPagination.currentPage || 1,
          limit: this.profitLossPerPage || 10,
          search: this.profitLossSearch || ''
        };

        const response = await SalesPersonTeusService.getProfitLossData(payload);

        if (response.data && response.data.status) {
          // Transform API data to match component field names and update data for child component via reactive props
          const transformedData = (response.data.data.profitLoss || []).map(item => ({
            pl_id: item.plId,
            pl_job_no: item.jobNo,
            pl_billing_party: item.billingParty,
            pl_expenses: item.expenses,
            pl_incomes: item.incomes,
            pl_profit: item.profit,
            pl_cu_relation: { employeeName: item.salesPerson || 'Unknown' },
            jobDetails: item.jobDetails
          }));

          this.profitLossData = transformedData;
          this.profitLossPagination = response.data.data.pagination || {};
          this.profitLossSummary = response.data.data.summary || {};
        } else {
          // Set empty data for child component
          this.profitLossData = [];
          this.profitLossPagination = { currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 10 };
          this.profitLossSummary = { totalRevenue: 0, totalExpenses: 0, netProfit: 0, profitMargin: 0 };
          this.alert.content = response.data.message || "Failed to fetch profit & loss data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching profit loss data:', error);
        // Set empty data for child component
        this.profitLossData = [];
        this.profitLossPagination = { currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 10 };
        this.profitLossSummary = { totalRevenue: 0, totalExpenses: 0, netProfit: 0, profitMargin: 0 };
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching profit & loss data";
        this.$refs.addPop.open();
      }
    },

    async loadExpenseData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.expensesPagination.currentPage,
          limit: this.expensesPerPage,
          search: this.expensesSearch
        };

        const response = await SalesPersonTeusService.getExpenseData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.expenseData = data.expenses || [];
          this.expensesPagination = data.pagination;
        } else {
          this.expenseData = [];
          this.alert.content = response.data.message || "Failed to fetch expense data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching expense data:', error);
        this.expenseData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching expense data";
        this.$refs.addPop.open();
      }
    },

    handleTallyReverseInvoiceDataLoaded(data) {
      this.tallyReverseInvoiceData = data.data || [];
      this.tallyReverseInvoicePagination = data.pagination || {};
    },

    handleQuotationsDataLoaded(data) {
      this.quotationsData = data.data || [];
      this.quotationsPagination = data.pagination || {};
    },

    handleAssignmentDataLoaded(data) {
      this.assignmentData = data.data || [];
      this.assignmentPagination = data.pagination || {};
    },

    handleProfitLossDataLoaded(data) {
      this.profitLossData = data.data || [];
      this.profitLossPagination = data.pagination || {};
    },

    async handleProfitLossDataLoad(payload) {
      await this.loadProfitLossData();
    },

    async loadTallyReverseInvoiceData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.tallyReverseInvoicePagination.currentPage,
          limit: this.tallyReverseInvoicePerPage,
          search: this.tallyReverseInvoiceSearch
        };

        const response = await SalesPersonTeusService.getTallyReverseInvoiceData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.tallyReverseInvoiceData = data.reverseInvoices || [];
          this.tallyReverseInvoicePagination = data.pagination;
        } else {
          this.tallyReverseInvoiceData = [];
          this.alert.content = response.data.message || "Failed to fetch tally reverse invoice data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching tally reverse invoice data:', error);
        this.tallyReverseInvoiceData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching tally reverse invoice data";
        this.$refs.addPop.open();
      }
    },

    async loadOutstandingData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          page: this.outstandingPagination.currentPage,
          limit: this.outstandingPerPage,
          search: this.outstandingSearch
        };

        const response = await SalesPersonTeusService.getOutstandingData(payload);

        if (response.data && response.data.status) {
          const data = response.data.data;
          this.outstandingData = {
            totalOutstanding: data.totalOutstanding || 0,
            outstandingInvoices: data.outstandingInvoices || [],
            count: data.count || 0
          };
          this.outstandingPagination = data.pagination;
        } else {
          this.outstandingData = {
            totalOutstanding: 0,
            outstandingInvoices: [],
            count: 0
          };
          this.alert.content = response.data.message || "Failed to fetch outstanding data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching outstanding data:', error);
        this.outstandingData = {
          totalOutstanding: 0,
          outstandingInvoices: [],
          count: 0
        };
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching outstanding data";
        this.$refs.addPop.open();
      }
    },

    async loadProfitLossData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString()
        };

        const response = await SalesPersonTeusService.getProfitLossData(payload);

        if (response.data && response.data.status) {
          this.profitLossData = response.data.data;
        } else {
          this.profitLossData = {
            totalRevenue: 0,
            totalExpenses: 0,
            netProfit: 0,
            profitMargin: 0,
            details: []
          };
          this.alert.content = response.data.message || "Failed to fetch profit loss data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching profit loss data:', error);
        this.profitLossData = {
          totalRevenue: 0,
          totalExpenses: 0,
          netProfit: 0,
          profitMargin: 0,
          details: []
        };
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching profit loss data";
        this.$refs.addPop.open();
      }
    },

    async loadExpenseData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString()
        };

        const response = await SalesPersonTeusService.getExpenseData(payload);

        if (response.data && response.data.status) {
          this.expenseData = response.data.data || [];
        } else {
          this.expenseData = [];
          this.alert.content = response.data.message || "Failed to fetch expense data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching expense data:', error);
        this.expenseData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching expense data";
        this.$refs.addPop.open();
      }
    },

    async loadTallyReverseInvoiceData() {
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString()
        };

        const response = await SalesPersonTeusService.getTallyReverseInvoiceData(payload);

        if (response.data && response.data.status) {
          this.tallyReverseInvoiceData = response.data.data || [];
        } else {
          this.tallyReverseInvoiceData = [];
          this.alert.content = response.data.message || "Failed to fetch tally reverse invoice data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching tally reverse invoice data:', error);
        this.tallyReverseInvoiceData = [];
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching tally reverse invoice data";
        this.$refs.addPop.open();
      }
    },

    // Load summary data (kept for backward compatibility)
    async getData() {
      this.isLoading = true;
      try {
        const payload = {
          salesPersonId: this.salesPersonFilter,
          clientId: this.clientFilter,
          dateRange: this.getDateRangeString(),
          branchFilter: this.branchfilter,
          statusFilter: this.statusFilter,
          assignmentTypeFilter: this.assignmentTypeFilter,
          transportTypeFilter: this.transportTypeFilter,
          is_nomination_shipper:this.is_nomination_shipper
        };

        const response = await SalesPersonTeusService.getSalesPersonDashboardData(payload);

        if (response.data && response.data.status) {
          const dashboardData = response.data.data;

          if (dashboardData.summary) {
            this.summaryData = Object.assign({}, this.summaryData, dashboardData.summary);
            if (dashboardData.summary.assignmentRate !== undefined) {
              this.summaryData.assignmentRate = dashboardData.summary.assignmentRate;
            }
          }
        } else {
          this.alert.content = response.data.message || "Failed to fetch dashboard data";
          this.$refs.addPop.open();
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        this.alert.content = (error.response && error.response.data && error.response.data.message) || "An error occurred while fetching dashboard data";
        this.$refs.addPop.open();
      } finally {
        this.isLoading = false;
      }
    },

    // Pagination methods for each tab
    onLeadsPageChange(page) {
      this.leadsPagination.currentPage = page;
      this.loadLeadsData();
    },

    onTopClientsPageChange(page) {
      this.topClientsPagination.currentPage = page;
      this.loadTopClientsData();
    },

    onQuotationsPageChange(page) {
      this.quotationsPagination.currentPage = page;
      this.loadQuotationsData();
    },

    onAssignmentsPageChange(page) {
      this.assignmentsPagination.currentPage = page;
      this.loadAssignmentsData();
    },

    onBillingPageChange(page) {
      this.billingPagination.currentPage = page;
      this.loadBillingData();
    },

    onActiveClientsPageChange(page) {
      this.activeClientsPagination.currentPage = page;
      this.loadActiveClientsData();
    },

    onOutstandingPageChange(page) {
      this.outstandingPagination.currentPage = page;
      this.loadOutstandingData();
    },

    onEnquiriesPageChange(page) {
      this.enquiriesPagination.currentPage = page;
      this.loadEnquiriesData();
    },

    onProfitLossPageChange(page) {
      this.profitLossPagination.currentPage = page;
      this.loadProfitLossData();
    },

    onExpensesPageChange(page) {
      this.expensesPagination.currentPage = page;
      this.loadExpenseData();
    },

    onTallyReverseInvoicePageChange(page) {
      this.tallyReverseInvoicePagination.currentPage = page;
      this.loadTallyReverseInvoiceData();
    },

    // Search methods for each tab
    onLeadsSearch() {
      this.leadsPagination.currentPage = 1;
      this.loadLeadsData();
    },

    onQuotationsSearch() {
      this.quotationsPagination.currentPage = 1;
      this.loadQuotationsData();
    },

    onAssignmentsSearch() {
      this.assignmentsPagination.currentPage = 1;
      this.loadAssignmentsData();
    },

    onBillingSearch() {
      this.billingPagination.currentPage = 1;
      this.loadBillingData();
    },

    onActiveClientsSearch() {
      this.activeClientsPagination.currentPage = 1;
      this.loadActiveClientsData();
    },

    onOutstandingSearch() {
      this.outstandingPagination.currentPage = 1;
      this.loadOutstandingData();
    },

    onEnquiriesSearch() {
      this.enquiriesPagination.currentPage = 1;
      this.loadEnquiriesData();
    },

    onProfitLossSearch() {
      this.profitLossPagination.currentPage = 1;
      this.loadProfitLossData();
    },

    onExpensesSearch() {
      this.expensesPagination.currentPage = 1;
      this.loadExpenseData();
    },

    onTallyReverseInvoiceSearch() {
      this.tallyReverseInvoicePagination.currentPage = 1;
      this.loadTallyReverseInvoiceData();
    },

    setDefaultData() {
      // Set default empty data on error
      this.leadsData = [];
      this.topClientsData = [];
      this.quotationsData = [];
      this.assignmentData = [];
      this.billingData = [];
      this.activeClientsData = [];
      this.outstandingData = {
        totalOutstanding: 0,
        outstandingInvoices: [],
        count: 0
      };

      this.summaryData = {
        totalLeads: 0,
        convertedLeads: 0,
        pendingLeads: 0,
        totalRevenue: 0,
        totalQuotations: 0,
        totalBookings: 0,
        usedBookings: 0,
        unusedBookings: 0,
        assignmentRate: 0,
        totalClients: 0,
        activeClients: 0,
        outstandingAmount: 0,
      };
    },
    filterAssignmentData() {
      // In real implementation, this would filter based on API response
      // For now, this is static data filtering simulation
      let filtered = this.assignmentData;
      
      if (this.assignmentTypeFilter && this.assignmentTypeFilter !== "all") {
        filtered = filtered.filter(item => item.jobType === this.assignmentTypeFilter);
      }
      
      if (this.transportTypeFilter && this.transportTypeFilter !== "all") {
        filtered = filtered.filter(item => item.transportType === this.transportTypeFilter);
      }
      
      if (this.branchfilter) {
        // Filter by branch if needed
      }
      
      return filtered;
    },
    filterEnquiryData() {
      // Filter enquiry data based on selected filters
      let filtered = this.enquiryData;
      
      if (this.branchfilter) {
        // Filter by branch if needed
      }
      
      if (this.salesPersonFilter) {
        // Filter by sales person if needed
      }
      
      return filtered;
    },
    filterConsoleBookingData() {
      // Filter console booking data based on selected filters
      let filtered = this.consoleBookingData;
      
      if (this.branchfilter) {
        // Filter by branch if needed
      }
      
      return filtered;
    },
    filterBillingData() {
      // Filter billing data based on selected filters
      let filtered = this.billingData;
      
      if (this.assignmentTypeFilter && this.assignmentTypeFilter !== "all") {
        filtered = filtered.filter(item => item.jobType === this.assignmentTypeFilter);
      }
      
      if (this.branchfilter) {
        // Filter by branch if needed
      }
      
      return filtered;
    },
    sortBillingBy(column) {
      if (this.billingSortColumn === column) {
        this.billingSortDirection = this.billingSortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.billingSortColumn = column;
        this.billingSortDirection = 'desc';
      }
    },
    getBillingAmountClass(value) {
      if (!value || value === 0) return '';
      if (value > 500000) return 'text-success font-weight-bold'; // High (>₹5L)
      if (value > 200000) return 'text-info'; // Good (₹2L-5L)
      if (value > 50000) return 'text-warning'; // Medium (₹50K-2L)
      return 'text-muted'; // Low (<₹50K)
    },
    getBillingTooltip(value) {
      if (!value || value === 0) return 'No data available';
      const amount = this.formatCurrency(value);
      if (value > 500000) return 'High Billing: ' + amount + ' (Excellent Performance)';
      if (value > 200000) return 'Good Billing: ' + amount + ' (Good Performance)';
      if (value > 50000) return 'Medium Billing: ' + amount + ' (Average Performance)';
      return 'Low Billing: ' + amount + ' (Below Average Performance)';
    },
    clearFilter() {
      this.QDFilter = "1";
      this.branchfilter = "";
      this.statusFilter = "";
      this.assignmentTypeFilter = "all";
      this.transportTypeFilter = "all";
      this.is_nomination_shipper = "";
      this.getCurrentLastDate();

      // Only clear sales person and client filters if not coming from TEUs dashboard
      if (!this.isFromTeusDashboard) {
        this.salesPersonFilter = "";
        this.clientFilter = "";
        this.selectedClientName = null;
      }

      // Reload data with cleared filters
      this.getData();
    },

    loadStaticData() {
      // Load data dynamically based on filters
      this.getData();
    },
    formatDate(date) {
      if (!date) return "-";
      return DateFormat(date);
    },
    formatCurrency(amount) {
      if (!amount) return "₹0";
      return "₹" + amount.toLocaleString("en-IN");
    },
    exportToExcel() {
      this.ExcelBtnName = "Exporting...";
      // Static export functionality
      setTimeout(() => {
        this.ExcelBtnName = "Export";
        this.alert.content = "Data exported successfully";
        this.$refs.addPop.open();
      }, 2000);
    },
    getPDF() {
      // PDF export functionality
      window.print();
    },
    previousDash() {
      window.history.go(-1);
    },
    backToTeusDashboard() {
      // Navigate back to TEUs dashboard with the same filters
      this.$router.push({
        path: '/dashboard/sales-person-teus-dashboard',
        query: {
          salesPersonFilter: this.salesPersonFilter,
          transportTypeFilter: this.transportTypeFilter,
          branchfilter: this.branchfilter,
          dateRange: this.getDateRangeString()
        }
      });
    },
    getDateRangeString() {
      if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
        const startYear = new Date(this.dateRange.startDate).getFullYear();
        const endYear = new Date(this.dateRange.endDate).getFullYear();
        return `${startYear}-${endYear}`;
      }
      return undefined;
    },
    navigateToClientTeus(clientData) {
      // Navigate to Sales Person TEUs Dashboard with client data
      // If coming from TEUs dashboard, use the original filters
      const salesPersonId = this.isFromTeusDashboard ? this.salesPersonFilter : this.salesPersonFilter;

      this.$router.push({
        path: '/dashboard/sales-person-teus-dashboard',
        query: {
          clientId: clientData.clientId,
          clientName: clientData.clientName,
          salesPersonId: salesPersonId,
          fromSalesPersonDashboard: 'true'
        }
      });
    },
    getClientIdFromName(clientName) {
      if (!clientName) return null;
      const clientList = this.$store.getters['common/getAllClientList'] || [];
      const client = clientList.find(c => c && c.clientName === clientName);
      return client ? client.clientId : null;
    },
    getClientNameFromId(clientId) {
      if (!clientId) return 'Unknown Client'
      const clientList = this.$store.getters['common/getAllClientList'] || []
      const client = clientList.find(c => c.clientId == clientId)
      return client ? client.clientName : 'Unknown Client'
    },
    processPendingQueryParams() {
      if (!this.pendingQueryParams) return;

      console.log('Processing pending query params:', this.pendingQueryParams);

      // Check for query parameters from TEUs dashboard
      if (this.pendingQueryParams.fromTeusDashboard === 'true') {
        this.isFromTeusDashboard = true;

        // Set sales person filter
        if (this.pendingQueryParams.salesPersonFilter) {
          this.salesPersonFilter = this.pendingQueryParams.salesPersonFilter;
          console.log('Set sales person filter:', this.salesPersonFilter);
        }

        // Set client filter - prioritize direct clientFilter over lookup by name
        if (this.pendingQueryParams.clientFilter) {
          this.clientFilter = this.pendingQueryParams.clientFilter;
          console.log('Set client filter from param:', this.clientFilter);

          // Also set the client name if provided
          if (this.pendingQueryParams.clientName) {
            this.selectedClientName = decodeURIComponent(this.pendingQueryParams.clientName);
          }
        } else if (this.pendingQueryParams.clientName) {
          const clientName = decodeURIComponent(this.pendingQueryParams.clientName);
          const clientId = this.getClientIdFromName(clientName);
          this.clientFilter = clientId;
          this.selectedClientName = clientName;
          console.log('Set client filter:', clientId, 'from name:', clientName);
        }

        console.log('After processing - salesPersonFilter:', this.salesPersonFilter, 'clientFilter:', this.clientFilter);

        // Reload data for all tabs since filters have changed
        this.$nextTick(() => {
          this.loadLeadsData();
          this.loadEnquiriesData();
          this.loadTopClientsData();
          this.loadQuotationsData();
          this.loadAssignmentsData();
          this.loadConsoleBookingData();
          this.loadBillingData();
          this.loadActiveClientsData();
          this.loadOutstandingData();
          this.loadProfitLossData();
          this.loadExpenseData();
          this.loadTallyReverseInvoiceData();
        });
      }

      // Clear pending params after processing
      this.pendingQueryParams = null;
    },
    getSalesPersonName(userId) {
      if (!userId) return 'Unknown Sales Person'
      const userList = this.$store.getters['common/getAllUserList'] || []
      const user = userList.find(u => u.userId == userId)
      return user ? user.employeeName : 'Unknown Sales Person'
    },

    onTabChange(tabIndex) {
      // Load data for the selected tab when clicked
      switch (tabIndex) {
        case 0: // Overview tab - data is already loaded in getData()
          break;
        case 1: // Leads tab
          this.loadLeadsData();
          break;
        case 2: // Top Clients tab
          this.loadTopClientsData();
          break;
        case 3: // Profit & Loss tab
          this.loadProfitLossData();
          break;
        case 4: // Expenses tab
          this.loadExpenseData();
          break;
        case 5: // Tally Reverse Invoice tab
          this.loadTallyReverseInvoiceData();
          break;
        case 6: // Quotations tab
          this.loadQuotationsData();
          break;
        case 7: // Assignments tab
          this.loadAssignmentsData();
          break;
        // case 8: // Enquiries tab
        //   this.loadEnquiriesData();
          break;
        case 8: // Console Booking tab
          this.loadConsoleBookingData();
          break;
        case 9: // Billing tab
          this.loadBillingData();
          break;
        case 10: // Active Clients tab
          this.loadActiveClientsData();
          break;
        case 11: // Outstanding tab
          this.loadOutstandingData();
          break;
      }
    },
  },
};
</script>

<style scoped>
.gutr {
  padding: 15px;
}

.summary-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 24px;
  color: #fff;
}

.card-icon.bg-primary {
  background-color: #007bff;
}

.card-icon.bg-success {
  background-color: #28a745;
}

.card-icon.bg-warning {
  background-color: #ffc107;
}

.card-icon.bg-info {
  background-color: #17a2b8;
}

.card-icon.bg-danger {
  background-color: #dc3545;
}

.card-icon.bg-secondary {
  background-color: #6c757d;
}

.card-content h4 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
}

  .card-content p {
    margin: 5px 0 0 0;
    font-size: 14px;
    color: #7f8c8d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .summary-card-small {
    border-radius: 8px;
    padding: 15px;
    color: #fff;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .summary-card-small.bg-success {
    background-color: #28a745;
  }

  .summary-card-small.bg-danger {
    background-color: #dc3545;
  }

  .summary-card-small.bg-info {
    background-color: #17a2b8;
  }

  .summary-card-small.bg-warning {
    background-color: #ffc107;
    color: #212529;
  }

  .card-content-small h5 {
    margin: 0 0 10px 0;
    font-size: 14px;
    font-weight: 500;
    opacity: 0.9;
  }

  .card-content-small h4 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-danger {
    color: #dc3545 !important;
  }

.formCardDash {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 20px;
}

.card-header {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
  border-radius: 8px 8px 0 0;
}

.card-title {
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.table {
  font-size: 14px;
}

.table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Responsive Design */
@media (max-width: 768px) {
  .summary-card {
    margin-bottom: 15px;
  }

  .card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
    margin-right: 15px;
  }

  .card-content h4 {
    font-size: 24px;
  }

  .card-content p {
    font-size: 12px;
  }

  .table {
    font-size: 12px;
  }

  .formCardDash {
    margin-bottom: 15px;
  }
}

@media (max-width: 576px) {
  .summary-card {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }

  .card-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .card-content h4 {
    font-size: 20px;
  }
}

/* Billing Summary Table Styles */
.billing-summary-table {
  overflow-x: auto;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
}

.table-filters {
  margin-bottom: 15px;
}

.color-legend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
}

.sortable-header:hover {
  background-color: #e9ecef;
}

.sortable-header i {
  margin-left: 5px;
  font-size: 12px;
}

.fixed-header {
  background-color: #007bff !important;
  color: white !important;
  font-weight: 600;
  position: sticky;
  left: 0;
  z-index: 10;
}

.summary-header {
  background-color: #28a745 !important;
  color: white !important;
  font-weight: 600;
  position: sticky;
  right: 0;
  z-index: 10;
}

.month-header {
  background-color: #17a2b8 !important;
  color: white !important;
  text-align: center;
  font-weight: 600;
  min-width: 180px;
}

.sub-header {
  background-color: #e9ecef !important;
  font-weight: 500;
  text-align: center;
  font-size: 12px;
}

.fixed-cell {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 5;
  background-color: inherit;
}

.billing-cell {
  text-align: right;
  padding: 8px;
  white-space: nowrap;
  font-size: 13px;
}

.billing-total-cell {
  background-color: #f8f9fa;
}

.billing-export-cell {
  background-color: #e3f2fd;
}

.billing-import-cell {
  background-color: #fff3e0;
}

.summary-cell {
  background-color: #f0f8f0 !important;
  font-weight: 600;
}

.billing-summary-table tbody tr:hover .fixed-cell {
  background-color: #e9ecef;
}

.billing-summary-table table {
  width: 100%;
  border-collapse: collapse;
}

.billing-summary-table thead th {
  border: 1px solid #dee2e6;
  padding: 10px;
}

.billing-summary-table tbody td {
  border: 1px solid #dee2e6;
  padding: 8px;
}

.billing-summary-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.billing-summary-table tbody tr:hover {
  background-color: #e9ecef;
}

/* Client filter info styling */
.client-filter-info {
  margin-top: 5px;
}

.client-filter-info small {
  color: #6c757d;
  font-size: 12px;
}

.client-filter-info i {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// salesPersonDashboard.vue?4e0a32e9